import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'components/core/Link';

export default function FacilityRatingLabel({ reviewsUrl, numberOfRatings }) {
	return (
		<span className="review-count">
			Based on
			{' '}
			<Link
				href={reviewsUrl}
				secondary
				segmentLabel="reviews text"
			>
				<span
					itemProp="reviewCount"
				>
					{numberOfRatings}
				</span> {numberOfRatings === 1 ? 'review' : 'reviews'}
			</Link>
		</span>
	);
}

FacilityRatingLabel.propTypes = {
	reviewsUrl: PropTypes.string,
	numberOfRatings: PropTypes.number
};
